import { cn } from "@/lib/utils";

interface StepsIndicatorProps {
  currentStep: string;
  role: string;
}

export const StepsIndicator = ({ currentStep, role }: StepsIndicatorProps) => {
  const talentSteps = ['language', 'role', 'personal', 'portfolio'];
  const recruiterSteps = ['language', 'role', 'personal', 'opportunity'];
  
  const steps = role === 'talent' ? talentSteps : recruiterSteps;
  const currentIndex = steps.indexOf(currentStep);
  
  return (
    <div className="flex items-center justify-center gap-1 sm:gap-1.5 mt-4 mb-2 sm:mt-6 sm:mb-3">
      {steps.map((step, index) => (
        <div key={step} className="flex items-center">
          <div 
            className={cn(
              "h-1 w-1 sm:h-1.5 sm:w-1.5 rounded-full",
              index <= currentIndex ? "bg-primary" : "bg-gray-200"
            )}
          />
          {index < steps.length - 1 && (
            <div 
              className={cn(
                "h-0.5 w-2 sm:w-3",
                index < currentIndex ? "bg-primary" : "bg-gray-200"
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
};